import { Anschrift } from "./anschrift"
import { Kontaktdaten } from "./kontaktdaten"

export class Rechnungsperson {
    // BT-27, BT-44
    unternehmen = ""
    // BT-28, BT-45
    abweichenderHandelsname = ""
    // BT-31, BT-48
    umsatzsteuerId = ""
    // BT-29, BT-46
    eindeutigeKennung = ""
    // BT-29-1, BT-46-1
    eindeutigeKennungSchema = ""
    // BT-34, BT-49
    eRechnungsAdresse = ""
    // BT-34-1, BT-49-1
    // default EM = Electronic mail
    eRechnungsAdresseSchema = "EM"
    // BT-30, BT-47
    handelsregisterNr = ""
    // BT-30-1, BT-47-1
    handelsregisterNrSchema = ""

    //prevent loading BT-47 an dBT-47-1 on import
    withoutHandelsregister = false

    anschrift = new Anschrift()
    kontaktdaten = new Kontaktdaten()

    constructor(withoutHandelsregister: boolean) {
        this.withoutHandelsregister = withoutHandelsregister
    }

    toJSON() {
        return {
            unternehmen: this.unternehmen,
            abweichenderHandelsname: this.abweichenderHandelsname,
            umsatzsteuerId: this.umsatzsteuerId,
            eindeutigeKennung: this.eindeutigeKennung,
            eindeutigeKennungSchema:
                this.eindeutigeKennung.trim().length > 0 && this.eRechnungsAdresseSchema.trim().length > 0 ? this.eindeutigeKennungSchema : null,
            eRechnungsAdresse: this.eRechnungsAdresse,
            eRechnungsAdresseSchema:
                this.eRechnungsAdresse.trim().length > 0 && this.eRechnungsAdresseSchema.trim().length > 0 ? this.eRechnungsAdresseSchema : null,
            handelsregisterNr: !this.withoutHandelsregister ? this.handelsregisterNr : null,
            handelsregisterNrSchema: !this.withoutHandelsregister
                ? this.handelsregisterNr.trim().length > 0 && this.handelsregisterNrSchema.trim().length > 0
                    ? this.handelsregisterNrSchema
                    : null
                : null,
            anschrift: this.anschrift,
            kontaktdaten: this.kontaktdaten,
        }
    }
}
